import * as ActionTypes from './ActionTypes';
import { actionTypes } from 'react-redux-form';
import { baseUrl } from '../Shared/baseURL';
import { generatePrompt } from '../Shared/openAIPromptUtils';


export const SignIn = (SignInFormData, callback) => (dispatch) => {
   // console.log('SignInFormData: ' + JSON.stringify(SignInFormData));
    //alert (typeof callback)
    return fetch(baseUrl + 'users/login', {
        method: 'POST',
        body: JSON.stringify(SignInFormData),
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
    })
        .then(response => {
            if (response.ok) {
                // If the response is okay (HTTP status code 200-299), return the JSON data

                return response.json().then(data => {
                    callback(data); // Call the callback function with the data
                    return data; // Return the data to the next `.then()` block
                });
            } else {
                // If there is an error response, throw an error with the status and status text
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        })
        .then((responseData) => {
            // Handle the response data
            // Check if the response contains an err field
            if (responseData.err) {
                // If err field exists, handle the error
                //console.error('Sign In Error:', responseData.err);
                // Throw an error to propagate it to the next catch block
                throw new Error(responseData.err.message);
            } else {
                // If no err field, handle success
                //console.log('Sign Ip Success:', responseData);
                // Return the response data to the caller
                return responseData;
            }
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch request or JSON parsing
            console.error('Sign In Error:', error.message);
            // Throw the error again to propagate it to the caller
            throw error;
        });
};





export const SignUp = (SignupFormData) => (dispatch) => {
    console.log('SignupFormData: ' + JSON.stringify(SignupFormData));
    return fetch(baseUrl + 'users/signup', {
        method: 'POST',
        body: JSON.stringify(SignupFormData),
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
    })
        .then(response => {
            if (response.ok) {
                // If the response is okay (HTTP status code 200-299), return the JSON data
                return response.json();
            } else {
                // If there is an error response, throw an error with the status and status text
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                console.log('SignupFormData error: ' + error);
                error.response = response;
                throw error;
            }
        })
        .then((responseData) => {
            // Handle the response data
            // Check if the response contains an err field
            if (responseData.err) {
                // If err field exists, handle the error
                console.error('Sign Up Error:', responseData.err);
                // Display error message to the user
                //alert('Sign Up failed: ' + responseData.err.message);
                // Throw an error to propagate it to the next catch block
                throw new Error(responseData.err.message);
            } else {
                // If no err field, handle success
                console.log('Sign Up Success:', responseData);
                // Display success message to the user
                alert('Registration Successful!');
                // Return the response data to the caller
                return responseData;
            }
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch request or JSON parsing
            console.error('Sign Up Error:', error.message);
            // Display error message to the user
            alert('Sign Up could not be completed. Please try again later.');
            // Throw the error again to propagate it to the caller
            throw error;
        });
};

export const getOpenAIText = (strModel, strModelURL, strPrompt, onSuccessCallback) => (dispatch) => {
    // Direct browser-to-OpenAI calls were removed (STUD-611): this previously shipped a live
    // OpenAI API key in the public JS bundle. AI-assisted question generation now goes through
    // the authenticated, admin-gated backend endpoints used by Question Authoring Studio.
    const error = new Error('Direct AI question generation from this screen has been removed. Use Question Authoring Studio instead.');
    console.error(error.message);
    dispatch(commentsFailed(error.message));
    return Promise.reject(error);
}


export const saveUpdatesToLog = (id, subject, topic, subtopic, comment, noOfTasks, noOfDoneTasks) => (dispatch) => {

    const updatedLog = {
        id: id,
        subject: subject,
        topic: topic,
        subtopic: subtopic,
        comments: comment,
        noOfTasks: noOfTasks,
        noOfDoneTasks: noOfDoneTasks
    }

    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'dailylogs/' + id, {//mongodb
        method: 'PUT',
        body: JSON.stringify(updatedLog),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((dailylogs) => dispatch(saveLogUpdate(dailylogs))) //dispatch the action to the store. 
        .catch(error => {
            console.log('Add Task', error.message);
            alert('Your task could not be posted\nError: ' + error.message);
        });

}

export const saveLogUpdate = (dailylogs) => ({
    type: ActionTypes.SAVE_UPDATE_TO_LOG,
    payload: dailylogs
});


export const updateTaskStatus = (unique_id, dailylogid, tasks, task, status) => (dispatch) => {

    const updateTask = {

        id: dailylogid,
        tasks: ""
    }
    const index = tasks.tasks.findIndex(object => {
        return object.id === unique_id;
    });

    tasks.tasks[index].status = status;
    updateTask.tasks = tasks.tasks;

    //dispatch(addTask(JSON.stringify(updateTask)));
    console.log("JSON.stringify(updateTask) :" + JSON.stringify(updateTask));
    dispatch(addTask(updateTask));
}

//this is an action creator. When called, this dispatches action object to the reducer that results in a state change.
//The return of the function will be merged to your connected component as props
export const updateTask = (unique_id, dailylogid, tasks, task, status) => (dispatch) => {


    const updateTask = {

        id: dailylogid,
        tasks: ""
    }
    // const index = tasks.tasks.findIndex(object => {
    //     return object.id === unique_id;
    // });
    // tasks.tasks[index].status = status;
    updateTask.tasks = tasks.tasks;
    //console.log(baseUrl + 'tasks/' + dailylogid);
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks/' + dailylogid, {//mongodb
        method: 'PUT',
        body: JSON.stringify(updateTask),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((task) => dispatch(addTask(task))) //dispatch the action to the store. 
        .catch(error => {
            console.log('Add Task', error.message);
            alert('Your task could not be posted\nError: ' + error.message);
        });

}


//this is an action creator. When called, this dispatches action object to the reducer that results in a state change.
//The return of the function will be merged to your connected component as props
export const postTask = (unique_id, dailylogid, tasks, task, duedate) => (dispatch) => {

    //console.log('due: ' + duedate);
    const newTask = {
        id: unique_id,
        task: task,
        status: "Open",
        due: duedate
    }

    const updateTask = {

        id: dailylogid,
        tasks: ""
    }

    updateTask.tasks = tasks.tasks.concat(newTask);
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks/' + dailylogid, {//mongodb
        method: 'PUT',
        body: JSON.stringify(updateTask),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((task) => dispatch(addTask(task))) //dispatch the action to the store. 
        .catch(error => {
            console.log('Add Task', error.message);
            alert('Your task could not be posted\nError: ' + error.message);
        });

}

//this is an action creator. When called, this dispatches action object to the reducer that results in a state change.
//The return of the function will be merged to your connected component as props
//front end is not 
export const addNewTask = (unique_id, dailylogid, task, duedate) => (dispatch) => {


    const newTask = {

        id: dailylogid,
        tasks: [{
            id: unique_id,
            task: task,
            status: "Open",
            due: duedate
        }]
    }

    //    console.log(baseUrl + 'tasks');
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks', {//mongodb
        method: 'PUT',
        body: JSON.stringify(newTask),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((task) => {
            //console.log ("addTasks(task) :" + JSON.stringify(task))
            dispatch(addTasks(task))
            dispatch(addTaskstoAllTasks(task)) // this is to add the newly added task to the Alltasks property to be added to the dashboard
        }) //dispatch the action to the store.         
        // .then((task) => {
        //     console.log ("addTaskstoAllTasks(task) :" + JSON.stringify(task))
        //     dispatch(addTaskstoAllTasks(task))}) //dispatch the action to the store. 
        .catch(error => {
            console.log('Add Task', error.message);
            alert('Your task could not be posted\nError: ' + error.message);
        });

}

export const addTaskstoAllTasks = (task) => ({

    type: ActionTypes.ADD_TASK_TO_ALLTASKS,
    payload: task
})

export const newTask = (task) => ({

    type: ActionTypes.NEW_TASK,
    payload: task
})


export const addTask = (task) => ({

    type: ActionTypes.ADD_TASK,
    payload: task
})

export const addComment = (dailylogs) => ({

    type: ActionTypes.ADD_COMMENT,
    payload: dailylogs
})

export const getOpenAIData = (data) => ({

    type: ActionTypes.GET_OPEN_AI_RESPONSE,
    payload: data
})



export const postTaskCommon = (taskCommon, onSuccessCallback) => (dispatch) => {
    // const newTimeTblEntry = {
    //     subject: subject,
    //     startdate: startDate,
    //     repeatsevery: repeatsevery,
    //     interval:interval,
    //     startTime:startTime,
    //     endTime:endTime
    // }

    //newLog.date = new Date().toISOString();

    // alert("taskCommon " + taskCommon)
    // console.log("postTaskCommon :" + JSON.stringify(taskCommon));

    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks', {//mongodb
        method: 'POST',
        body: JSON.stringify(taskCommon),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    }).then(response => {
        if (response.ok) {
            return response;
        }
        else {
            var error = new Error('Error ' + response.status + ': ' + response.statusText);
            error.response = response;
            throw error;
        }
    },
        error => {
            var errmess = new Error(error.message);
            throw errmess;
        }
    )
        .then((response) => response.json())
        .then((task) => {
            //console.log ("addTasks(task) :" + JSON.stringify(task))
            //dispatch(addTasks(task))
            dispatch(addTaskstoAllTasks(task)) // this is to add the newly added task to the Alltasks property to be added to the dashboard


        }) //dispatch the action to the store.         
        .then(() => {
            //alert("before onSuccessCallback :" + typeof onSuccessCallback);
            if (typeof onSuccessCallback === 'function') {
                //  alert("before onSuccessCallback :" + typeof onSuccessCallback);
                onSuccessCallback();
            }

        })
        //.then((response) => console.log("response from action creator", response))        
        .catch(error => {
            console.log('Post timetable', error.message);
            alert('Your timetable could not be posted\nError: ' + error.message);
        });

}

export const updateTaskCommon = (taskCommon, taskId, onSuccessCallback) => (dispatch) => {
    // const newTimeTblEntry = {
    //     subject: subject,
    //     startdate: startDate,
    //     repeatsevery: repeatsevery,
    //     interval:interval,
    //     startTime:startTime,
    //     endTime:endTime
    // }

    //newLog.date = new Date().toISOString();

    // alert("taskId " + taskId)
    //console.log("updateTaskCommon :" + JSON.stringify(taskCommon));

    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks/' + taskId, {//mongodb
        method: 'PUT',
        body: JSON.stringify(taskCommon),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((task) => {
            console.log("updateTasks(task) :" + JSON.stringify(task))
            //dispatch(addTasks(task))
            dispatch(updateTaskToAllTasks(task)) // this is to add the newly added task to the Alltasks property to be added to the dashboard
            // Call the callback function (clearFilter) after the successful completion
            // alert("about to call clear filter from action creator");
            // alert(typeof onSuccessCallback);
            //onSuccessCallback.call(this);
            //onSuccessCallback();
            if (typeof onSuccessCallback === 'function') {

                onSuccessCallback();
            }
        }) //dispatch the action to the store.         
        //.then((response) => console.log("response from action creator", response))        
        .catch(error => {
            console.log('Post timetable', error.message);
            alert('Your timetable could not be posted\nError: ' + error.message);
        });

}


export const postTimeTable = (timetable) => (dispatch) => {
    // const newTimeTblEntry = {
    //     subject: subject,
    //     startdate: startDate,
    //     repeatsevery: repeatsevery,
    //     interval:interval,
    //     startTime:startTime,
    //     endTime:endTime
    // }

    //newLog.date = new Date().toISOString();
    //console.log(JSON.stringify(timetable));

    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'timetable', {//mongodb
        method: 'POST',
        body: JSON.stringify(timetable),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((response) => dispatch(addTimetable(response)))
        //.then((response) => console.log("response from action creator", response))        
        .catch(error => {
            console.log('Post timetable', error.message);
            alert('Your timetable could not be posted\nError: ' + error.message);
        });

}

export const deleteTimeTable = (timetable) => (dispatch) => {

    //console.log("update time table :" + JSON.stringify(timetable));
    //alert(JSON.stringify(timetable[0]._id));


    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'timetable/' + timetable[0]._id, {//mongodb
        method: 'DELETE',
        body: JSON.stringify(timetable),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((response) => {
            alert(JSON.stringify(response));
            dispatch(deleteTimetable(timetable[0]._id));

        })
        .catch(error => {
            console.log('Delete timetable', error.message);
            alert('Your timetable could not be deleted: ' + error.message);
        });

}

export const updateTimeTable = (timetable) => (dispatch) => {
    // const newTimeTblEntry = {
    //     subject: subject,
    //     startdate: startDate,
    //     repeatsevery: repeatsevery,
    //     interval:interval,
    //     startTime:startTime,
    //     endTime:endTime
    // }

    //newLog.date = new Date().toISOString();
    //    console.log("update time table :" + JSON.stringify(timetable));

    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'timetable/' + timetable._id, {//mongodb
        method: 'PUT',
        body: JSON.stringify(timetable),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((response) => dispatch(updTimetable(response)))
        .catch(error => {
            console.log('Update timetable', error.message);
            alert('Your timetable could not be updated\nError: ' + error.message);
        });

}



export const postComment = (id, date, subject, topic, subtopic, comment, callback) => (dispatch) => {
    const newLog = {
        id: id,
        subject: subject,
        topic: topic,
        subtopic: subtopic,
        comments: comment
    }

    newLog.date = new Date(date).toISOString();


    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'dailylogs', {//mongodb
        method: 'POST',
        body: JSON.stringify(newLog),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((response) => {
            dispatch(addComment(response));
            if (callback) callback(); // Invoke the callback on success
        })
        .catch(error => {
            console.log('Post comments', error.message);
            alert('Your comment could not be posted\nError: ' + error.message);
        });

}


export const fetchTimetables = () => (dispatch) => {
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'timetable', {//mongodb
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((timetable) => dispatch(getTimetables(timetable)))
        .catch(error => dispatch(commentsFailed(error.message)));
}

export const fetchComments = () => (dispatch) => {

    const token = localStorage.getItem('studyapp.com');

    return fetch(baseUrl + 'dailylogs', {//mongodb
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((dailylogs) => dispatch(addComments(dailylogs)))
        .catch(error => dispatch(commentsFailed(error.message)));

}

export const fetchTasks = (id) => (dispatch) => {
    dispatch(tasksLoading(true));
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks/' + id, {//mongodb
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((tasks) => dispatch(addTasks(tasks)))
        .catch(error => dispatch(tasksFailed(error.message)));
}

export const fetchAllTasks = (id) => (dispatch) => {
    //dispatch(tasksLoading(true));
    const token = localStorage.getItem('studyapp.com');
    return fetch(baseUrl + 'tasks', {//mongodb
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'

    })
        .then(response => {
            if (response.ok) {
                return response;
            }
            else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            }
        )
        .then((response) => response.json())
        .then((tasks) => dispatch(getAllTasks(tasks)))
        .catch(error => dispatch(tasksFailed(error.message)));
}

//this is to update the state via redux as and when we type into the textboxes so that the new letters are displayed on the textboxes
//otherwise textboxes will appear locked
export const updateLog = (id, subject, topic, subtopic, comment) => (dispatch) => {
    const updatedLog = {
        id: id,
        subject: subject,
        topic: topic,
        subtopic: subtopic,
        comments: comment
    }
    //const newLog = JSON.stringify(updatedLog);

    dispatch(syncLog(updatedLog));
}

export const syncLog = (dailylogs) => ({
    type: ActionTypes.UPDATE_LOG,
    payload: dailylogs
});

export const addComments = (dailylogs) => ({
    type: ActionTypes.ADD_COMMENTS,
    payload: dailylogs
});

export const addTimetable = (timetables) => ({
    type: ActionTypes.ADD_TIMETABLE,
    payload: timetables
});

export const updTimetable = (timetables) => ({
    type: ActionTypes.UPDATE_TIMETABLE,
    payload: timetables
});

export const deleteTimetable = (timetables) => ({
    type: ActionTypes.DELETE_TIMETABLE,
    payload: timetables
});



export const getTimetables = (timetables) => ({
    type: ActionTypes.GET_TIMETABLES,
    payload: timetables
});

export const getAllTasks = (tasks) => ({

    type: ActionTypes.GET_ALL_TASKS,
    payload: tasks
})

export const addTasks = (tasks) => ({

    type: ActionTypes.ADD_TASKS,
    payload: tasks
})

export const updateTaskToAllTasks = (tasks) => ({

    type: ActionTypes.UPDATE_TASK_TO_ALL_TASKS,
    payload: tasks
})

export const commentsFailed = (errmess) => ({
    type: ActionTypes.COMMENTS_FAILED,
    payload: errmess
});

export const tasksFailed = (errmess) => ({
    type: ActionTypes.TASKS_FAILED,
    payload: errmess
});

export const tasksLoading = () => ({
    type: ActionTypes.TASKS_LOADING

});